export default {
    methods: {
        userHasPermission(user, availableRoles, availableModules, apiOnly = false) {
            let hasModule = true
            let hasRole = true

            if (availableRoles.length) {
                hasRole =
                    availableRoles.filter((role) => {
                        return user.has_roles.includes(role)
                    }).length > 0
            }

            if (availableModules.length) {
                hasModule =
                    availableModules.filter((mod) => {
                        return user.has_modules.includes(mod)
                    }).length > 0
            }

            if (apiOnly && !(user.company.url_prefix != null)) {
                return false
            }
            return hasModule && hasRole
        },
        isManagerOfUser(currentUser, user) {
            return currentUser.id == user.manager.id
        },
        isCommitteeMember(currentUserCommittees, userCommittees) {
            const evaluatorCommitteesIds = currentUserCommittees.map((committee) => committee.id)
            const ratedCommitteesIds = userCommittees.map((committee) => (committee.id ? committee.id : committee))
            for (const id of evaluatorCommitteesIds) {
                if (ratedCommitteesIds.includes(id)) return true
            }
            return false
        },
        canViewUserEvaluationsResults(currentUser, user) {
            if (
                this.currentUserHasRolePermissionsOf([
                    'administrator',
                    'local_administrator',
                    'god',
                    'is_values_master',
                    'is_manager',
                ])
            ) {
                return true
            }

            if (this.isCommitteeMember(currentUser.evaluator_committees, user.rated_committees)) {
                return true
            }

            if (currentUser.id == user.id) {
                return true
            }

            return false
        },
        hasEventPermission(permissions, module, level, permission) {
            return permissions[module][level][permission]
        },
        currentUserHasRolePermissionsOf(roles = []) {
            const currentUser = this.$store.state.currentUser.user
            const rolesPermission = this.userHasPermission(currentUser, roles, [])
            return rolesPermission
        },
    },
}
